import { Button, Stack } from "@mui/material";
import React, { useEffect } from "react";
import Modal, { CommonModalProps } from "..";
import { ObjectType } from "../../../Core/Api/Types/object-type";
import { SetPlayerInput } from "../../../Redux/Reducers/redux-slice-react-player";
import { useAppDispatch } from "../../../Redux/redux-store";
import ReactPlayerWrapper from "../../MediaPlayer/ReactPlayerWrapper/player-wrapper";
import { SetPlayerAspectRatio, SetPlayerHeight, SetPlayerResponsive } from "../../../Redux/Reducers/redux-slice-layout";
import { PreviewContext } from "../../../Pages/admin/Inventory/InventoryAssetSingle/AssetSinglePreview/asset-single-preview";
import { useTranslation } from "react-i18next";

export type ModalPreviewElementProps = {
  onClose?: (props: any) => void;
  objectId: number;
  episodeNb?: number | null;
  type: ObjectType;
  title?: string;
};

export type ModalPreviewProps = CommonModalProps<ModalPreviewElementProps>;

const ModalPreview = React.forwardRef<any, ModalPreviewProps>((props, ref) => {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();
  const { closeModal, onClose } = props;

  useEffect(() => {
    dispatch(SetPlayerInput({ objectId: props.objectId, episode: props.episodeNb ?? null, shareMediaKey: null }));
    dispatch(SetPlayerResponsive(true));
    dispatch(SetPlayerAspectRatio("16/9"));
    dispatch(SetPlayerHeight(null));
  }, [props.objectId]);

  return (
    <Modal
      title={
        props.title
          ? props.title
          : t("modal:title.previewAsset", { type: props.type.toLowerCase(), id: props.objectId })
      }
      reference={ref}
      closeModal={closeModal}
      width={800}
      footer={
        <Stack direction="row" justifyContent="flex-end">
          <Button variant="outlined" onClick={closeModal}>
            {t("common:close")}
          </Button>
        </Stack>
      }
    >
      {(props.type === ObjectType.Video || props.type === ObjectType.Audio || props.type === ObjectType.Subtitle) && (
        <>
          <ReactPlayerWrapper context={PreviewContext.Modal} assetType={props.type} />
        </>
      )}
    </Modal>
  );
});

export default ModalPreview;
